<template>
  <portal to="ModalRecommendation">
    <div>
      <div
        id="modalRecommendation"
        class="modal fade"
        role="dialog"
        aria-labelledby="modalRecommendation"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body">
              <div class="d-flex justify-content-end">
                <img
                  src="@/assets/icon/close.png"
                  alt="close"
                  class="is-pointer"
                  @click="closeModalRecommendation"
                >
              </div>
              <h5 class="text-center font-weight-bold mb-3">
                {{ $t("modal-recommendation.title") }}
              </h5>
              <div
                v-if="loadingList"
                class="px-3 text-center loading-height"
              >
                <div class="spinner-border spinner-border-sm">
                  <span class="sr-only">
                    Loading...
                  </span>
                </div>
              </div>
              <div
                v-if="!loadingList"
                class="dynamic-recommendations px-md-4 mb-4"
              >
                <div
                  v-for="(question, i) in listQuestion"
                  :key="i"
                  class="parent-question"
                >
                  <p class="question">
                    <strong v-if="$i18n.locale === 'en'">{{
                      question.titleEng
                    }}</strong>
                    <strong v-if="$i18n.locale === 'id'">{{
                      question.titleIdn
                    }}</strong>
                  </p>

                  <!-- PARENT ANSWERS -->

                  <textarea
                    v-if="question.type === 'textbox'"
                    v-model="resultQuestion[i].value"
                    class="form-control ml-3 col-11"
                    rows="4"
                  />
                  <div
                    v-for="(questionAnswer, j) in question.questionAnswers"
                    :key="j"
                  >
                    <input
                      v-if="question.type === 'radio_button'"
                      v-model="resultQuestion[i].value"
                      type="radio"
                      class="input-question ml-3"
                      :value="questionAnswer.id"
                      @change="checkValue(i)"
                    >
                    <input
                      v-if="question.type === 'checkbox'"
                      v-model="resultQuestion[i].value"
                      type="checkbox"
                      class="input-question ml-3"
                      :value="questionAnswer.id"
                      :disabled="hasOppositeValue(i, questionAnswer.value)"
                    >
                    <label
                      :for="questionAnswer.titleEng"
                      class="label-question"
                    >
                      <span v-if="$i18n.locale === 'en'">{{
                        questionAnswer.titleEng
                      }}</span>
                      <span v-if="$i18n.locale === 'id'">{{
                        questionAnswer.titleIdn
                      }}</span>
                    </label>
                  </div>
                  <input
                    v-if="showOther.isOpen && i === 3"
                    v-model="showOther.value"
                    type="text"
                    class="form-control form-control-sm ml-3 col-11"
                  >

                  <div
                    v-if="!$v.showOther.value.required &&
                      $v.showOther.value.$error &&
                      i === 3"
                    ref="showOther"
                    class="ml-3"
                  >
                    <small class="text-danger">
                      {{ $t("form-question.question-required") }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <button
                  v-if="loadingSubmit"
                  type="button"
                  class="btn btn-info px-5 py-2"
                >
                  <div class="text-center">
                    <div class="spinner-border spinner-border-sm">
                      <span class="sr-only">
                        Loading...
                      </span>
                    </div>
                  </div>
                </button>
                <button
                  v-if="!loadingSubmit"
                  type="button"
                  class="btn btn-info px-5 py-2"
                  @click="submit"
                >
                  <small class="font-weight-bold">
                    {{ $t("modal-recommendation.button") }}
                  </small>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalSuccess
      v-if="modal.success"
      class="in-front-of"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      class="in-front-of"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </portal>
</template>

<script>
import { RECOMMENDATION_ID } from '@/fixtures'
import Api from '@/utils/Api'
import $ from 'jquery'
import { requiredIf } from 'vuelidate/lib/validators'
import { format } from 'date-fns'
import ModalSuccess from '@/components/modal/ModalSuccess'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'

const TYPE_INITIAL_VALUES = {
  radio_button: '',
  checkbox: [],
  textbox: ''
}

export default {
  name: 'ModalRecommendation',

  components: {
    ModalSuccess,
    ModalUnsuccessful
  },

  props: {
    idRecommendation: {
      type: String,
      default: () => ('')
    }
  },

  data () {
    return {
      user: JSON.parse(localStorage.getItem('profile')) || {},
      showOther: {
        isOpen: false,
        value: ''
      },
      listQuestion: null,
      loadingList: false,
      resultQuestion: [],
      resultQuestionChildren: [],
      modal: {
        success: false,
        unsuccessful: false,
        recommendation: false,
        textModal: ''
      },
      loadingSubmit: false
    }
  },

  mounted () {
    this.getQuestion()
  },

  methods: {
    closeModalRecommendation () {
      $('#modalRecommendation').modal('hide')
      this.$emit('closeModal', 'recommendation')
    },
    async getQuestion () {
      this.loadingList = true
      const { data } = await Api.surveys.get(RECOMMENDATION_ID)
      this.listQuestion = data.questions
      this.loadingList = false
      this.initialModel()
    },
    initialModel () {
      this.resultQuestion = this.listQuestion.map(({ id, type }) => ({
        id,
        value: TYPE_INITIAL_VALUES[type],
        openChildren: false,
        type: type
      }))
    },
    hasOppositeValue (questionIndex, value) {
      return Array.isArray(this.resultQuestion[questionIndex].value)
        ? this.resultQuestion[questionIndex].value
          .find(id => this.listQuestion[questionIndex].questionAnswers
            .find(answer => answer.id === id)
            .value !== value
          )
        : false
    },
    async submit () {
      this.$v.$reset()
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$refs.showOther[0].focus()
        return
      }

      this.loadingSubmit = true
      const form = {
        date: format(new Date(), 'yyyy-MM-dd'),
        nric: this.user.nric,
        language: this.$i18n.locale.toUpperCase(),
        parentId: this.idRecommendation,
        surveyResponseAnswers: [
          ...this.resultQuestion.map(({ id, value, type }) => ({
            questionId: id,
            questionAnswerId: this.checkValueAnswerNotText(type, value),
            value: this.checkValueAnswerText(id, type, value)
          }))
        ]
      }
      const { data } = await Api.surveys.saveResponses(RECOMMENDATION_ID, form)
      this.loadingSubmit = false
      if (data.status === 40109 || data.status === 40003 || data.status === 422) {
        this.modal.textModal = this.$i18n.locale === 'en' ? data.message.messageEng : data.message.messageIdn
        this.showModal('unsuccessful')
      } else {
        this.modal.textModal = this.$t('modal-recommendation.success')
        this.showModal('success')
      }
    },
    checkValueAnswerNotText (type, value) {
      if (type !== 'textbox') {
        return Array.isArray(value) ? value : [value]
      } else {
        return ''
      }
    },
    checkValueAnswerText (id, type, value) {
      if (type === 'textbox') {
        return value
      } else {
        if (id === 'fd68d53d-e65f-40a4-a665-1e532c9e3032') {
          return this.showOther.value
        } else {
          return ''
        }
      }
    },
    checkValue (index) {
      if (index === 3) {
        this.showOther.isOpen = this.resultQuestion[index].value === '948085a8-cb34-4fad-88fd-f748065e6cf1'
      }
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      this.closeModalRecommendation()
    }
  },

  validations: {
    showOther: {
      value: {
        required: requiredIf(function () {
          return this.showOther.isOpen
        })
      }
    }
  }
}
</script>

<style scoped>
.is-pointer {
  cursor: pointer;
}
.dynamic-recommendations {
  height: 470px;
  overflow: auto;
}
.parent-question {
  margin-bottom: 20px;
}
.question {
  color: #121212;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.input-question {
  margin-right: 10px;
}
.label-question {
  font-size: 12px;
  vertical-align: middle;
  font-weight: 500;
  padding-top: 5px;
}
textarea {
  resize: none;
  font-size: 12px;
}
.in-front-of {
  z-index: 10000;
}
.loading-height {
  height: 500px;
}
</style>
